module.exports = __webpack_public_path__ + "./docs/img/icon-linkedin.fc650bbedf1609ccfb6d3e3391189755.svg";